<template>
  <b-modal
    :id="'contact-call-center-' + input.id.toString()"
    centered
    hide-footer
    hide-header
    size="xl"
    :visible="true"
    @hide="done()"
  >
    <ProcessingGif :classes="'popup-processing-image'" />
    <template v-if="!isLoading">
      <b-row v-if="!!criticalError" class="alert-messages">
        <b-col>
          <b-alert show variant="danger">{{errorMessage}}</b-alert>
        </b-col>
      </b-row>
      <ContactSupportForm
        :lifeline-type="lifelineType"
        :session="session"
        :contacted="contacted"
        @email="sendMessage"
      >
      </ContactSupportForm>
      <b-row v-if="!isLifelineEmail" class="justify-content-center boxes">
        <b-col cols="10" sm="6" md="4" lg="3">
          <b-button block @click="done()" variant="primary" class="btn-account">
            <span class="inline-button-label" v-html="input.formatted_label"></span>&nbsp;
          </b-button>
        </b-col>
      </b-row>
      <b-link block class="centered-block close-button" variant="secondary" @click="done()">&times;</b-link>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import ContactSupportForm from './ContactSupportForm'
import { LifelineType } from '@/constants'
import { getErrorMessage } from '@/utils'
import ProcessingGif from '@/components/ProcessingGif'

export default {
  name: 'ContactSupport',
  components: {ProcessingGif, ContactSupportForm},
  props: {
    input: Object,
    session: Object,
    orderSummary: Boolean,
    contacted: Boolean
  },
  data: function() {
    return {
      lifelineType: null
    }
  },
  computed: {
    ...mapState(['campaign', 'criticalError', 'isLoading']),
    errorMessage: function() {
      return getErrorMessage(this.criticalError)
    },
    isLifelineEmail: function() {
      return this.lifelineType === LifelineType.Email
    }
  },
  methods: {
    done: function(isOrderSummary = false) {
      this.$store.commit('reset_lifeline')
      this.$emit('done', isOrderSummary) // we're done with the contact form, move on to the next step
    },
    sendMessage: function(contactForm) {
      this.$store.commit('busy')
      this.$store.dispatch('email', contactForm)
        .then(session => {
          this.$store.commit('messages', [
            'Your message has been successfully sent to us.<br/>We will get back to you soon.'
          ])
          this.done(this.orderSummary)
        })
        .catch(err => {
          // sending email failed - show error and phone number
          console.log(err)
          this.lifelineType = LifelineType.Phone
          this.$store.commit('lifeline_error', err)
        })
    }
  },
  created() {
    let lifelineType = LifelineType.Email // default value

    if (this.session && this.session.lifeline_type) {
      lifelineType = this.session.lifeline_type
    }

    if (lifelineType === LifelineType.Email) {
      if (this.campaign && this.campaign.support_email_fields && this.campaign.support_email_fields.length) {
        lifelineType = LifelineType.Email
      } else {
        // if call center closed, but nothing else is available, show the phone number
        lifelineType = LifelineType.Phone
      }
    }
    if (lifelineType === LifelineType.Phone && !(this.session && this.session.phone_contact_url)) {
      lifelineType = LifelineType.Email
    }

    this.lifelineType = lifelineType
  }
}
</script>

<style scoped>

</style>
